import React, { useEffect, useState } from "react";

import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { YMInitializer } from "react-yandex-metrika";
import ModalSupport from "./features/ModalSupport";

import { CloseButton } from "./components/NotifyMessage/NotifyMessage.jsx";
import { routeList } from "./router";

import CityListContext from "./context/cityList";
import { apiFetchCityList } from "./api/methods/cities";

import { CNS_INFO_STYLES } from "./utils/consts/index.js";
import appMetaData from "../package.json";

function App() {
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    console.info("%c[APP]", CNS_INFO_STYLES, `App version: ${appMetaData.version}`);
  }, []);

  useEffect(() => {
    apiFetchCityList().then(setCityList);
  }, []);

  return (
    <div className="app-container">
      <CityListContext.Provider value={cityList}>
        <RouterProvider router={routeList} />
        <ModalSupport />
        <ToastContainer closeButton={CloseButton} />
      </CityListContext.Provider>

      <YMInitializer
        accounts={[67339603]}
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
        }}
      />
    </div>
  );
}

export default App;
